import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteImages } from '../../../_global/fragments/generated/CompleteImages';
import { ProjectWorkspaceInfo } from '../../workspaces/fragments/generated/ProjectWorkspaceInfo';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectNameFragment = { __typename?: 'Project', id: string, name: string };

export type FavoriteTreeItemInfoFragment = { __typename?: 'FavoriteTreeItem', id: string, name?: string | null, projectId?: string | null, type?: string | null, favorited?: boolean | null, emoji?: string | null };

export type GetProjectHashtagsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetProjectHashtagsQuery = { __typename?: 'Query', availHashtags?: Array<{ __typename?: 'LocalHashtag', name: string, id: string } | null> | null };

export type GetProjectNameQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetProjectNameQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, name: string } | null } | null };

export type GetProjectForNavigationQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetProjectForNavigationQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, adobeAssetId?: string | null, name: string, rootAssetId: string, workspaceId: string, archivedAt?: string | null, fileCount: number, ignoreArchive: boolean, isWorkfront?: boolean | null, memberCount?: number | null, notificationsEnabled?: boolean | null, private: boolean, storage: number, uniqueMemberCount?: number | null, workspace?: { __typename?: 'Workspace', id: string, name: string, projectCount?: number | null, accountId?: string | null } | null, images: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null }, permissions?: { __typename?: 'ProjectPermissions', canViewWorkspace: boolean } | null } | null } | null };

export type SetHashtagMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  hashtag: Types.Scalars['String']['input'];
}>;


export type SetHashtagMutation = { __typename?: 'Mutation', setHashtag: { __typename?: 'LocalHashtag', id: string, name: string } };

export type GetAssetFavoritesQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetAssetFavoritesQuery = { __typename?: 'Query', assetFavorites?: { __typename?: 'LocalFavoriteAssetResponse', result?: { __typename?: 'FavoriteTreeBranch', id: string, children?: Array<{ __typename?: 'FavoriteTreeItem', id: string, name?: string | null, projectId?: string | null, type?: string | null, favorited?: boolean | null, emoji?: string | null } | null> | null } | null } | null };

export type GetAssetFavoritedQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
  projectId: Types.Scalars['ID']['input'];
  assetId: Types.Scalars['ID']['input'];
}>;


export type GetAssetFavoritedQuery = { __typename?: 'Query', isAssetFavorited: boolean };

export type SetProjectFavoriteMutationVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
  projectId: Types.Scalars['ID']['input'];
  favorited: Types.Scalars['Boolean']['input'];
}>;


export type SetProjectFavoriteMutation = { __typename?: 'Mutation', setProjectFavorite: boolean };

export type SetAssetFavoriteMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  userId: Types.Scalars['ID']['input'];
  assetId: Types.Scalars['ID']['input'];
  name: Types.Scalars['String']['input'];
  type: Types.FavoriteAssetTypes;
  favorited: Types.Scalars['Boolean']['input'];
}>;


export type SetAssetFavoriteMutation = { __typename?: 'Mutation', setAssetFavorite: boolean };

export type SetFolderOpenMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  userId: Types.Scalars['ID']['input'];
  folderId: Types.Scalars['ID']['input'];
}>;


export type SetFolderOpenMutation = { __typename?: 'Mutation', setProjectFolderOpen: boolean };

export const ProjectName = /*#__PURE__*/ gql`
    fragment ProjectName on Project {
  id
  name
}
    ` as unknown as DocumentNode<ProjectNameFragment, unknown>;
export const FavoriteTreeItemInfo = /*#__PURE__*/ gql`
    fragment FavoriteTreeItemInfo on FavoriteTreeItem {
  id
  name
  projectId
  type
  favorited
  emoji
}
    ` as unknown as DocumentNode<FavoriteTreeItemInfoFragment, unknown>;
export const GetProjectHashtags = /*#__PURE__*/ gql`
    query GetProjectHashtags($projectId: ID!) {
  availHashtags(projectId: $projectId) @client {
    name
    id
  }
}
    ` as unknown as DocumentNode<GetProjectHashtagsQuery, GetProjectHashtagsQueryVariables>;
export const GetProjectName = /*#__PURE__*/ gql`
    query GetProjectName($projectId: ID!) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      ...ProjectName
    }
  }
}
    ${ProjectName}` as unknown as DocumentNode<GetProjectNameQuery, GetProjectNameQueryVariables>;
export const GetProjectForNavigation = /*#__PURE__*/ gql`
    query GetProjectForNavigation($projectId: ID!) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      id
      adobeAssetId
      name
      rootAssetId
      workspaceId
      workspace {
        id
        name
        projectCount
        accountId
      }
      images {
        ...CompleteImages
      }
      permissions {
        canViewWorkspace
      }
      ...ProjectWorkspaceInfo
    }
  }
}
    ${CompleteImages}
${ProjectWorkspaceInfo}` as unknown as DocumentNode<GetProjectForNavigationQuery, GetProjectForNavigationQueryVariables>;
export const SetHashtag = /*#__PURE__*/ gql`
    mutation SetHashtag($projectId: ID!, $hashtag: String!) {
  setHashtag(projectId: $projectId, hashtag: $hashtag) @client {
    id
    name
  }
}
    ` as unknown as DocumentNode<SetHashtagMutation, SetHashtagMutationVariables>;
export const GetAssetFavorites = /*#__PURE__*/ gql`
    query GetAssetFavorites($userId: ID!, $projectId: ID!) {
  assetFavorites(userId: $userId, projectId: $projectId) @client {
    result {
      id
      children {
        ...FavoriteTreeItemInfo
      }
    }
  }
}
    ${FavoriteTreeItemInfo}` as unknown as DocumentNode<GetAssetFavoritesQuery, GetAssetFavoritesQueryVariables>;
export const GetAssetFavorited = /*#__PURE__*/ gql`
    query GetAssetFavorited($userId: ID!, $projectId: ID!, $assetId: ID!) {
  isAssetFavorited(userId: $userId, projectId: $projectId, assetId: $assetId) @client
}
    ` as unknown as DocumentNode<GetAssetFavoritedQuery, GetAssetFavoritedQueryVariables>;
export const SetProjectFavorite = /*#__PURE__*/ gql`
    mutation SetProjectFavorite($userId: ID!, $projectId: ID!, $favorited: Boolean!) {
  setProjectFavorite(
    userId: $userId
    projectId: $projectId
    favorited: $favorited
  ) @client
}
    ` as unknown as DocumentNode<SetProjectFavoriteMutation, SetProjectFavoriteMutationVariables>;
export const SetAssetFavorite = /*#__PURE__*/ gql`
    mutation SetAssetFavorite($projectId: ID!, $userId: ID!, $assetId: ID!, $name: String!, $type: FavoriteAssetTypes!, $favorited: Boolean!) {
  setAssetFavorite(
    userId: $userId
    projectId: $projectId
    assetId: $assetId
    name: $name
    type: $type
    favorited: $favorited
  ) @client
}
    ` as unknown as DocumentNode<SetAssetFavoriteMutation, SetAssetFavoriteMutationVariables>;
export const SetFolderOpen = /*#__PURE__*/ gql`
    mutation SetFolderOpen($projectId: ID!, $userId: ID!, $folderId: ID!) {
  setProjectFolderOpen(
    userId: $userId
    projectId: $projectId
    folderId: $folderId
  ) @client
}
    ` as unknown as DocumentNode<SetFolderOpenMutation, SetFolderOpenMutationVariables>;

        

        
export const useProjectNameFragment = (
  input: string | Omit<UseFragmentOptions<ProjectNameFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectNameFragment>({
    fragment: ProjectName,
    fragmentName: 'ProjectName',
    ...options,
  });
};
  
        
        

        
export const useFavoriteTreeItemInfoFragment = (
  input: string | Omit<UseFragmentOptions<FavoriteTreeItemInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'FavoriteTreeItem' } };
    return input;
  })();

  return useFragment<FavoriteTreeItemInfoFragment>({
    fragment: FavoriteTreeItemInfo,
    fragmentName: 'FavoriteTreeItemInfo',
    ...options,
  });
};
  
        
          

          export const useGetProjectHashtagsQuery = (options?:QueryHookOptions<GetProjectHashtagsQuery, GetProjectHashtagsQueryVariables>) => useQuery(GetProjectHashtags, options);

          

          export type GetProjectHashtagsQueryOptions = QueryHookOptions<GetProjectHashtagsQuery, GetProjectHashtagsQueryVariables>;

          

          export const useGetProjectHashtagsLazyQuery = (options?:LazyQueryHookOptions<GetProjectHashtagsQuery, GetProjectHashtagsQueryVariables>) => useLazyQuery(GetProjectHashtags, options);

          

          export type GetProjectHashtagsQueryResult = ReturnType<typeof useGetProjectHashtagsQuery>;

          

          

          export const useGetProjectNameQuery = (options?:QueryHookOptions<GetProjectNameQuery, GetProjectNameQueryVariables>) => useQuery(GetProjectName, options);

          

          export type GetProjectNameQueryOptions = QueryHookOptions<GetProjectNameQuery, GetProjectNameQueryVariables>;

          

          export const useGetProjectNameLazyQuery = (options?:LazyQueryHookOptions<GetProjectNameQuery, GetProjectNameQueryVariables>) => useLazyQuery(GetProjectName, options);

          

          export type GetProjectNameQueryResult = ReturnType<typeof useGetProjectNameQuery>;

          

          

          export const useGetProjectForNavigationQuery = (options?:QueryHookOptions<GetProjectForNavigationQuery, GetProjectForNavigationQueryVariables>) => useQuery(GetProjectForNavigation, options);

          

          export type GetProjectForNavigationQueryOptions = QueryHookOptions<GetProjectForNavigationQuery, GetProjectForNavigationQueryVariables>;

          

          export const useGetProjectForNavigationLazyQuery = (options?:LazyQueryHookOptions<GetProjectForNavigationQuery, GetProjectForNavigationQueryVariables>) => useLazyQuery(GetProjectForNavigation, options);

          

          export type GetProjectForNavigationQueryResult = ReturnType<typeof useGetProjectForNavigationQuery>;

          

          

          export const useSetHashtagMutation = (options?:MutationHookOptions<SetHashtagMutation, SetHashtagMutationVariables>) => useMutation(SetHashtag, options);
          

          export type SetHashtagMutationOptions = MutationHookOptions<SetHashtagMutation, SetHashtagMutationVariables>;

          

          export type SetHashtagMutationResult = ReturnType<typeof useSetHashtagMutation>[1];

          

          

          export const useGetAssetFavoritesQuery = (options?:QueryHookOptions<GetAssetFavoritesQuery, GetAssetFavoritesQueryVariables>) => useQuery(GetAssetFavorites, options);

          

          export type GetAssetFavoritesQueryOptions = QueryHookOptions<GetAssetFavoritesQuery, GetAssetFavoritesQueryVariables>;

          

          export const useGetAssetFavoritesLazyQuery = (options?:LazyQueryHookOptions<GetAssetFavoritesQuery, GetAssetFavoritesQueryVariables>) => useLazyQuery(GetAssetFavorites, options);

          

          export type GetAssetFavoritesQueryResult = ReturnType<typeof useGetAssetFavoritesQuery>;

          

          

          export const useGetAssetFavoritedQuery = (options?:QueryHookOptions<GetAssetFavoritedQuery, GetAssetFavoritedQueryVariables>) => useQuery(GetAssetFavorited, options);

          

          export type GetAssetFavoritedQueryOptions = QueryHookOptions<GetAssetFavoritedQuery, GetAssetFavoritedQueryVariables>;

          

          export const useGetAssetFavoritedLazyQuery = (options?:LazyQueryHookOptions<GetAssetFavoritedQuery, GetAssetFavoritedQueryVariables>) => useLazyQuery(GetAssetFavorited, options);

          

          export type GetAssetFavoritedQueryResult = ReturnType<typeof useGetAssetFavoritedQuery>;

          

          

          export const useSetProjectFavoriteMutation = (options?:MutationHookOptions<SetProjectFavoriteMutation, SetProjectFavoriteMutationVariables>) => useMutation(SetProjectFavorite, options);
          

          export type SetProjectFavoriteMutationOptions = MutationHookOptions<SetProjectFavoriteMutation, SetProjectFavoriteMutationVariables>;

          

          export type SetProjectFavoriteMutationResult = ReturnType<typeof useSetProjectFavoriteMutation>[1];

          

          

          export const useSetAssetFavoriteMutation = (options?:MutationHookOptions<SetAssetFavoriteMutation, SetAssetFavoriteMutationVariables>) => useMutation(SetAssetFavorite, options);
          

          export type SetAssetFavoriteMutationOptions = MutationHookOptions<SetAssetFavoriteMutation, SetAssetFavoriteMutationVariables>;

          

          export type SetAssetFavoriteMutationResult = ReturnType<typeof useSetAssetFavoriteMutation>[1];

          

          

          export const useSetFolderOpenMutation = (options?:MutationHookOptions<SetFolderOpenMutation, SetFolderOpenMutationVariables>) => useMutation(SetFolderOpen, options);
          

          export type SetFolderOpenMutationOptions = MutationHookOptions<SetFolderOpenMutation, SetFolderOpenMutationVariables>;

          

          export type SetFolderOpenMutationResult = ReturnType<typeof useSetFolderOpenMutation>[1];

          
